<template>
  <el-form
    :model="form"
    ref="form">
    <h4 class="blue-text">{{L10n('company')}}</h4>
    <div class="row">
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('name')"
          prop="name"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            :value="form.name"
            @input="form.name = valueTrimLeft($event)"/>
        </el-form-item>
      </div>
    </div>
    <h4 class="blue-text">{{L10n('company-details')}}</h4>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-12">
        <el-form-item
          :label="L10n('company-type')"
          prop="companyTypeID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-response
            :model.sync="form.companyTypeID"
            :data="dataSourceCompanyType.records"
            :isLoading="dataSourceCompanyType.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-3 col-12">
        <el-form-item
          :label="L10n('country')"
          prop="country"
          :rules="getValidationRule('required')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.country"
            @input="form.country = valueTrimLeft($event)"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-3 col-12">
        <el-form-item
          :label="L10n('city')"
          prop="city"
          class="material-style">
          <el-input
            :value="form.city"
            @input="form.city = valueTrimLeft($event)"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-3 col-12">
        <el-form-item
          :label="L10n('street')"
          prop="street"
          class="material-style">
          <el-input
            :value="form.street"
            @input="form.street = valueTrimLeft($event)"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-12">
        <el-form-item
          :label="L10n('zip-code')"
          prop="zipCode"
          class="material-style">
          <el-input
            :value="form.zipCode"
            @input="form.zipCode = valueTrimLeft($event)"/>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-3 col-12">
        <el-form-item
          :label="L10n('state')"
          prop="state"
          class="material-style">
          <el-input
            :value="form.state"
            @input="form.state = valueTrimLeft($event)"/>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-3 col-12">
        <el-form-item
          :label="L10n('address-type-division')"
          prop="addressTypeDivisionID"
          class="material-style">
          <select-response
            :model.sync="form.addressTypeDivisionID"
            :data="dataSourceCompanyType.records"
            :isLoading="dataSourceCompanyType.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-3 col-12">
        <el-form-item
          :label="L10n('score')"
          prop="scoreID"
          class="material-style">
          <select-response
            :model.sync="form.scoreID"
            :fields="{id: 'id', title: 'scoreText'}"
            :data="dataSourceScore.records"
            :isLoading="dataSourceScore.loading"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <h4 class="blue-text">{{L10n('contact')}}</h4>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('name')"
          prop="contactName"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="secondField"
            :value="form.contactName"
            @input="form.contactName = valueTrimLeft($event)"/>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('email')"
          prop="email"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="fourthField"
            :value="form.email"
            @input="form.email = valueTrimLeft($event)"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('phone')"
          prop="phone"
          class="material-style">
          <el-input
            ref="sixthField"
            :value="form.phone"
            @input="form.phone = valueTrimLeft($event)"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('division')"
          prop="divisionID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-response
            :model.sync="form.divisionID"
            :data="dataSourceDivision.records"
            :isLoading="dataSourceDivision.loading"
          ></select-response>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormSelectPartNumber',
  mixins: [Form],
  computed: {
    dataSourceCompanyType () {
      return this.API('CompanyTypes/GetAllDynamic?select=id,title')
    },
    dataSourceDivision () {
      return this.API('Divisions/GetAllDynamic?select=id,title')
    },
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText')
    }
  }
}
</script>
